import { atom } from 'recoil';
import {
  ITimelineResultDesignSetting,
  defaultTimelineResultDesignSetting,
} from '@typings/setting/timelineSetting.interface';

export const timelineResultDesignState = atom<ITimelineResultDesignSetting>({
  key: 'timelineResultDesignState',
  default: defaultTimelineResultDesignSetting,
});

export const timelineResultDesignLoadedState = atom<boolean>({
  key: 'timelineResultDesignLoadedState',
  default: false,
});
